"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpStatusCode = void 0;
var HttpStatusCode;
exports.HttpStatusCode = HttpStatusCode;

(function (HttpStatusCode) {
  HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
  HttpStatusCode[HttpStatusCode["SUCCESS"] = 200] = "SUCCESS";
  HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
  HttpStatusCode[HttpStatusCode["TEMPORARY_REDIRECT"] = 302] = "TEMPORARY_REDIRECT";
  HttpStatusCode[HttpStatusCode["INVALID_REQUEST"] = 400] = "INVALID_REQUEST";
  HttpStatusCode[HttpStatusCode["INVALID_CREDENTIALS"] = 401] = "INVALID_CREDENTIALS";
  HttpStatusCode[HttpStatusCode["UNAUTHORIZED_REQUEST"] = 403] = "UNAUTHORIZED_REQUEST";
  HttpStatusCode[HttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode[HttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode[HttpStatusCode["MISSING_QUERY_PARAM"] = 422] = "MISSING_QUERY_PARAM";
  HttpStatusCode[HttpStatusCode["MISSING_DATA"] = 422] = "MISSING_DATA";
  HttpStatusCode[HttpStatusCode["INVALID_DATA"] = 422] = "INVALID_DATA";
  HttpStatusCode[HttpStatusCode["SERVER_ERROR"] = 500] = "SERVER_ERROR";
  HttpStatusCode[HttpStatusCode["UNIMPLEMENTED_ERROR"] = 501] = "UNIMPLEMENTED_ERROR";
})(HttpStatusCode || (exports.HttpStatusCode = HttpStatusCode = {}));